import qs from "qs";
import { VB_URL_PARAMS, VIRTUAL_BORE_EVENTS } from "./constants";

/**
 * Parse virtual bore parameters from URL
 */
export const parseVirtualBoreParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const vbLat = urlParams.get(VB_URL_PARAMS.LAT);
  const vbLon = urlParams.get(VB_URL_PARAMS.LON);

  // Check for coordinates
  if (vbLat && vbLon) {
    const lat = parseFloat(vbLat);
    const lon = parseFloat(vbLon);
    if (!isNaN(lat) && !isNaN(lon)) {
      return { coordinates: { lat, lon } };
    }
  }

  return null;
};

/**
 * Clear virtual bore parameters from URL
 */
export const clearVirtualBoreParams = () => {
  const currentParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  // Remove virtual bore parameters
  delete currentParams[VB_URL_PARAMS.LAT];
  delete currentParams[VB_URL_PARAMS.LON];

  const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}${newSearch}`
  );

  // Notify listeners
  window.dispatchEvent(new CustomEvent(VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED));
};

/**
 * Format coordinate for display
 */
export const formatCoordinate = (coord, decimals = 6) => {
  if (coord === null || coord === undefined) return "N/A";
  return coord.toFixed(decimals);
};

/**
 * Format elevation for display
 */
export const formatElevation = (elevation) => {
  if (elevation === null || elevation === undefined) return "N/A";
  return `${elevation} ft msl`;
};

/**
 * Validate virtual bore API response
 */
export const validateVirtualBoreResponse = (response) => {
  if (!response || typeof response !== "object") {
    return { isValid: false, error: "Invalid response format" };
  }

  if (!Array.isArray(response.data)) {
    return { isValid: false, error: "Invalid data format" };
  }

  if (response.data.length === 0) {
    return { isValid: false, error: "No data available for these coordinates" };
  }

  return { isValid: true };
};
